export const AuthConstants = {
	UserName_LocalStorage_Key: 'Key:UserName'
};
Object.freeze(AuthConstants);